<template>
  <div>
    <div class="row">
      <McAlert
        v-if="isOverCapacity"
        class="col-12 col-md-3 capacity-alert"
        variant="warning"
        withIcon
        :text="$t('delivery.overload')"
      />
    </div>

    <div class="row">
      <div class="col-12 col-md-3">
        <FormulateInput
          v-bind="field"
          validation-behavior="live"
          class="p-0"
          :value="computedValue"
          :fullObject="fullObject"
          @input="handleInput"
          @update:fullObject="$emit('update:fullObject', $event)"
        />
      </div>
      <div class="col-12 col-md-3">
        <div class="read-only">
          <div class="label">Kapasitas</div>
          <div class="value">{{ computedBoxCapacity }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert'

export default {
  components: {
    McAlert,
  },
  props: {
    value: {},
    field: {},
    fullObject: {},
    totalWeights: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return this.value
    },
    computedBoxCapacity() {
      let value = 'Pilih Jenis Box Dahulu'

      if (this.value) {
        value = `${this.fullObject.weight_capacity || '-'} Kg`
      }

      return value
    },
    isOverCapacity() {
      const weightCapacity = this.fullObject?.weight_capacity

      if (weightCapacity === undefined) return false

      return (weightCapacity || 0) < (this.totalWeights || 0)
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.read-only {
  .label {
    color: $mep-color-text-200;
  }

  .value {
    color: $mep-color-text-300;

    &.bold {
      color: $mep-color-text-400;
      font-weight: 600;
    }
  }
}

.capacity-alert {
  margin: 0 12px 8px;
}
</style>
